import graphql from "babel-plugin-relay/macro";

export const BLOCKOUT_DATE_FRAGMENT = graphql`
	fragment blockoutDateModal_BlockoutDateFragment on BlockoutDate {
		from
		to
	}
`;
